module.exports = __webpack_public_path__ + "media/images/top/product_t-5e28202443a718992f843ff75736daca.gif";